// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3l6VT","options":"AnswerScale_options__1zX2B","selected":"AnswerScale_selected__1efmS"};